export const STORAGE_KEY = "telemon-tv";

let syncedData = {
  packages: [],
  home: {
    categories: [],
    carousel: [],
  },
  contact: {},
  about: {
    sections: [],
  },
  requests: [],
  news: [],
  user: {},
  userAdmin:[],
  users:[],
  carouselMovil: [],
  newCategories:[]
};

if (localStorage.getItem(STORAGE_KEY)) {
  syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY));
}

export const state = syncedData;
